<template>
    <div class="flex flex-col py-4 bg-white mb-4">
        <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
            <div class="flex">
                <feather-icon
                    class="mr-2"
                    icon="MessageSquareIcon"
                    svgClasses="text-black stroke-current w-36.96 h-36.96"
                ></feather-icon>
                <h4>Idiomas</h4>
            </div>

            <vs-button
                class="mobile-hidden"
                size="small"
                color="primary"
                type="border"
                icon="edit"
                @click="navigateToSelectedStep"
            >
                Editar
            </vs-button>

            <vs-button
                class="sm:hidden"
                size="small"
                color="primary"
                type="border"
                icon="edit"
                @click="navigateToSelectedStep"
            />
        </vs-col>

        <hr class="my-4 line"/>

        <div v-if="show()" class="p-4 language-detail--card">
            <div
                v-for="(item, index) in languages"
                :key="`language-detail-${index}`"
                class="language-detail--card__info"
            >
                <div
                    v-if="item.name != null || item.name != undefined"
                    class="language-detail--status"
                >
                    <div class="language-detail--status__img" :style="{backgroundColor: color}">
                        {{ item.name.substr(0, 2).toUpperCase() }}
                    </div>
                </div>
                <div class="language-detail--content">
                    <div class="language-detail__title">
                        {{ formatTitle(item.name) }}
                    </div>
                    <div
                        v-if="item.name != null || item.name != undefined"
                        class="language-detail__subtitle"
                    >
                        {{ item.name.split(' ').pop() }}
                    </div>
                </div>
            </div>
        </div>
        <EmptyDetailCard
            v-else
            description="Você ainda não preencheu nenhuma informação de idiomas..."
        />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard'

export default {
    name: 'simple-languages',
    computed: {
        ...mapState('language', ['languages']),
        ...mapState('company', ['company']),

        color() {
            return this.company.base_hexcolor || '#1551b1'
        }
    },
    methods: {
        navigateToSelectedStep() {
            this.updateCurrentStep({ order: 6 })
            this.$router.push({ name: 'step-languages' })
        },

        formatTitle(title) {
            let _title = '';
            let splited = title.split(' ');

            splited.pop();

            splited.forEach(item => {
                if (_title === '') {
                    _title = item;
                } else {
                    _title = _title+' '+item;
                }
            })
            return _title;
        },
        
        show() {
            return this.languages.length > 0
        },
        ...mapActions('step', ['updateCurrentStep'])
    },

    components: {
        EmptyDetailCard
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/resume/simple.scss";
@import '@/assets/scss/talent/components/languagedetailcard.scss';

hr{
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>